import axios from 'axios'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://192.168.2.9:8701', // api的base_url--本地
  // baseURL: 'https://hbdfgwprod.yiqichuangying.com', // api的base_url--测试
  baseURL: 'https://hbdfprod.bydst.cn', // api的base_url--正式
  timeout: 30000 // 请求超时时间
})

// 请求拦截
service.interceptors.request.use(
  config => {
    // 这里可以加入token等信息
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// 响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5000
      })
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/requests.js